import { Billboard as t, Html as o } from "@react-three/drei";
import { memo as n } from "react";
import { ScreenSizer as i } from "../../3d/screen-sizer/index.js";
import { jsx as r } from "react/jsx-runtime";
const h = n(function({
  onClick: e
}) {
  return /* @__PURE__ */ r(t, {
    children: /* @__PURE__ */ r(i, {
      children: /* @__PURE__ */ r("object3D", {
        children: /* @__PURE__ */ r(o, {
          center: !0,
          children: /* @__PURE__ */ r("button", {
            style: {
              border: "1px solid #ccc",
              width: 25,
              height: 25,
              borderRadius: 25 * 0.5,
              transform: "translateY(-100%)",
              userSelect: "none",
              cursor: "pointer"
            },
            onClick: e,
            children: "-"
          })
        })
      })
    })
  });
});
export {
  h as PointDeleteBtn
};
//# sourceMappingURL=index.js.map
